import React from "react";
import { FormProvider } from "react-hook-form";
import { ToastContainer } from "react-toastify";

import Loader from "../../../../components/Loader";
import UserCentralDropDown from "../../../../components/shared/UserCentralDropDown";
import {
    serviceRequestHeadContainer,
    serviceRequestTitle,
    userDropDown
} from "../../../../common/cssclasses";

import { useInternationalBreedingCertificate } from "../hooks/useInternationalBreedingCertificate";

// Sections
import IBCStallionSection from "../Components/IBCStallionSection";
import IBCMareSection from "../Components/IBCMareSection";
import IBCCoveringSection from "../Components/IBCCoveringSection";
import IBCCommentsSection from "../Components/IBCCommentsSection";
import IBCTermsSection from "../Components/IBCTermsSection";
import IBCActionButtons from "../Components/IBCActionButtons";

export default function InternationalBreedingCertificateRequestPage() {
    const {
        methods,
        isLoading,
        serviceTitle,
        referenceNumber,
        showUserDropDown,
        handleOwnerChange,
        eligibleCertificatesData,
        isReadOnly,
        onCertificateChange,
        colors,
        countries,
        commentsData,
        termsList,
        actionButtonsProps
    } = useInternationalBreedingCertificate();

    return (
        <FormProvider {...methods}>
            <div className={`page-overlay text-center ${isLoading ? "classdisplay" : "classnotdisplay"}`}>
                <div className="loaderDiv"><Loader /></div>
            </div>
            <ToastContainer position="top-right" theme="colored" autoClose={5000} />

            <div className={serviceRequestHeadContainer}>
                <h2 className={serviceRequestTitle}>
                    {serviceTitle} {referenceNumber ? `- ${referenceNumber}` : ""}
                </h2>
                {showUserDropDown && (
                    <div className={userDropDown}>
                        <UserCentralDropDown onChange={handleOwnerChange} />
                    </div>
                )}
            </div>

            <IBCStallionSection
                eligibleCertificates={eligibleCertificatesData}
                isReadOnly={isReadOnly}
                onCertificateChange={onCertificateChange}
            />

            <IBCMareSection
                colors={colors}
                countries={countries}
                isReadOnly={isReadOnly}
            />

            <IBCCoveringSection isReadOnly={isReadOnly} />

            <IBCCommentsSection {...commentsData} />

            <IBCTermsSection
                termsList={termsList}
                isReadOnly={isReadOnly}
                isNotNewRequest={Boolean(actionButtonsProps.id)}
            />

            <IBCActionButtons {...actionButtonsProps} />
        </FormProvider>
    );
}
